//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['resident', 'itemtype'],
  data: function data() {
    return {
      modalName: "modify-ledger-payment",
      payment: {},
      residents: [],
      moveToResidentId: 0,
      reversal: false,
      reversalReasons: [],
      reversalReasonId: 0,
      reversalReasonNFSId: 0,
      reversalReasonMoveId: 0,
      reasonNSF: false,
      reasonMove: false,
      notes: '',
      remove: false,
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    Event.$on('edit-ledger-payment-resident', function (payment) {
      _this.payment = payment;

      axios.post('/prototype/resident/ledger/payments/fetch', { id: payment.id }).then(function (response) {
        _this.payment = response.data;
      });

      var $el = _this;
      axios.get('/prototype/accounting/accounts-receivable/billings/reversal-reasons').then(function (response) {
        $el.reversalReasons = [];
        response.data.forEach(function (r, index) {
          //there are two "hard-coded" reasons that we want to grab
          // in case those buttons are pushed
          if (r.fixed_code === 'NSF') {
            $el.reversalReasonNFSId = r.id;
          }

          if (r.fixed_code === 'PAYMR') {
            $el.reversalReasonMoveId = r.id;
          }

          $el.reversalReasons.push({
            label: r.reason,
            value: r.id
          });
        });
      });

      axios.get('/prototype/properties/residents').then(function (response) {
        $el.residents = [];
        response.data.forEach(function (r, index) {
          $el.residents.push({
            label: r.unit.name + ': ' + r.person.first_name + ' ' + r.person.last_name,
            value: r.id
          });
        });
      });

      Event.$emit("open-slide", _this.modalName);
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off('edit-ledger-payment-resident');
    this.reversal = false;
  },
  mounted: function mounted() {
    var _this2 = this;

    Event.$on('close-full-modal', function () {
      _this2.reversal = false;
    });
    Event.$on('close-slide', function () {
      Object.assign(_this2.$data, _this2.$options.data());
      _this2.reversal = false;
    });
  },

  methods: {
    removeNSFPayment: function removeNSFPayment() {
      var $el = this;
      $el.reasonNSF = true;
      $el.reasonMove = false;
      $el.reversalReasonId = $el.reversalReasonNFSId;
      $el.reversal = true;
    },
    removeMovePayment: function removeMovePayment() {
      var $el = this;
      $el.reasonNSF = false;
      $el.reasonMove = true;
      $el.reversalReasonId = $el.reversalReasonMoveId;
      $el.reversal = true;
    },
    removePayment: function removePayment() {
      var _this3 = this;

      this.reversal = true;
      this.loading = true;

      var p = this.payment;
      p.deposit = null;
      p.ledger = null;
      p.reversalReasonId = this.reversalReasonId;
      p.notes = this.notes;
      p.moveToResidentId = this.moveToResidentId;

      if (p.moveToResidentId) {
        var moveToResident = this.residents.find(function (r) {
          return r.value == _this3.moveToResidentId;
        });
        p.notes = 'Payment moved from Resident ' + this.resident.unit.name + ': ' + this.resident.person.first_name + ' ' + this.resident.person.last_name + ': to Resident: ' + moveToResident.label + '. ' + p.notes;
      }

      axios.post('/prototype/resident/ledger/payments/destroy', p).then(function (response) {
        if (response.data.error) {
          _this3.$snotify.error(response.data.error);
        } else {
          _this3.$snotify.success('Payment Reversed');
          _this3.payment = {};
          _this3.$children[0].showSmallModal = false;
          _this3.remove = false;
          _this3.loading = false;

          if (_this3.itemtype === 'applicant') {
            Event.$emit('refresh-applicant-ledger');
          }

          if (_this3.itemtype === 'resident') {
            Event.$emit('refresh-resident-ledger');
            Event.$emit("update-resident-balance");
            Event.$emit("update-resident-detail");
          }

          if (_this3.itemtype === 'pastresident') {
            Event.$emit('refresh-past-resident-ledger');
            Event.$emit("update-resident-balance");
            Event.$emit("update-resident-detail");
          }
        }
      }).then(function () {
        Event.$emit("close-slide", _this3.modalName);
      });
    },
    close: function close() {
      this.reversal = false;
      Event.$emit("close-slide", this.modalName);
      Event.$emit("close-full-modal", this.modalName);
    },
    updateReasonForReversal: function updateReasonForReversal(selectedVal) {
      this.reversalReasonId = selectedVal ? selectedVal.value : null;
    },
    updateResidentForReversal: function updateResidentForReversal(selectedVal) {
      this.moveToResidentId = selectedVal ? selectedVal.value : null;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentModifyLedgerPaymentSlideout.vue
// module id = dFzP
// module chunks = 0 1